import axios from 'axios';
import useAuthStore from '../store/useAuthStore';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:9000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Додаємо перехоплювач помилок
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Отримуємо функцію logout зі store
      const logout = useAuthStore.getState().logout;
      logout();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// Додаємо токен до кожного запиту, якщо він є
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default axiosInstance; 